module.exports = __webpack_public_path__ + "img/avatar2.8940ddac.png";